'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/DotsSixVertical.es.js";
const t = a.forwardRef((e$1, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...e$1, weights: e }));
t.displayName = "DotsSixVerticalIcon";
const m = t;
export {
  m as DotsSixVertical,
  t as DotsSixVerticalIcon
};
